import React from 'react';
import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import configureStore, { history } from './store';
import App from './App';

export const store = configureStore();

const MainApp = () => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Switch>
          <Route component={App} />
        </Switch>
      </ConnectedRouter>
    </Provider>

  )
};


export default MainApp;